// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';

type Props = {
  children: Node,
};

export function Select({ children, ...rest }: Props): Node {
  return (
    <Root>
      <SelectComponent {...rest}>
        {children}
      </SelectComponent>

      <svg xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M12 21l-12-18h24z"/>
      </svg>
    </Root>
  );
}

export const Root = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 16px;
    top: 50%;
    height: 8px;
    width: auto;
    margin-top: -4px;
    fill: #999;
    pointer-events: none;
  }
`;

export const SelectComponent = styled.select`
  appearance: none;
  width: 100%;
  line-height: 50px;
  background: none;
  border: 1px solid ${props => props.theme.colors.gray(88)};
  border-radius: calc(${props => props.theme.radius} / 2);
  padding: 0 16px;
  outline: 0;

  &[readonly] {
    pointer-events: none;
    touch-action: none;
  }

  :focus {
    border-color: ${props => props.theme.colors.primary(50)};
    box-shadow: inset 0 0 0 1px ${props => props.theme.colors.primary(50)};
  }

  ${props => props.fashion === 'error' && css`
    border-color: ${props => props.theme.colors.error(51)};
  `}
`;
